import { useEffect, useState } from 'react';

import { t } from 'modules/i18n';
import { closeNotification, showNotification } from 'modules/notifications';

import { useConnectMutation } from '../actions/connect';
import { CONNECTION_CACHE_KEY } from '../const';
import { removeStoredWalletId, restoreWalletId } from '../utils/storeWalletId';

const NOTIFICATION_KEY = 'restoreConnection';
const CONNECT_TIMEOUT_MS = 500;
const RESET_TIMEOUT_MS = 10_000;

export const useRestoreConnection = (): boolean => {
  const [isProviderConnectionAttempted, setProviderConnectionAttempted] =
    useState(false);

  const [connect, { isLoading, reset }] = useConnectMutation({
    fixedCacheKey: CONNECTION_CACHE_KEY,
  });

  useEffect(() => {
    const walletId = restoreWalletId();

    if (walletId) {
      const connectTimeoutId = setTimeout(() => {
        removeStoredWalletId();

        try {
          void connect(walletId).unwrap();
        } catch {
          showNotification({ message: t(`notification.connectionRecovery`) });
        } finally {
          setProviderConnectionAttempted(true);
        }
      }, CONNECT_TIMEOUT_MS);

      return () => {
        clearTimeout(connectTimeoutId);
      };
    }

    setProviderConnectionAttempted(true);
  }, [connect]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!isProviderConnectionAttempted && isLoading) {
        reset();
        setProviderConnectionAttempted(true);
        closeNotification(NOTIFICATION_KEY);
      }
    }, RESET_TIMEOUT_MS);

    return () => clearTimeout(timeoutId);
  }, [reset, isProviderConnectionAttempted, isLoading]);

  return isProviderConnectionAttempted;
};
